document.addEventListener('DOMContentLoaded', function() {
  // 获取按钮
  var topButton = document.getElementById("top-btn");

  // 当用户滚动页面超过200像素时显示按钮
  window.onscroll = function() {
    scrollFunction();
  };

  function scrollFunction() {
    if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
      topButton.style.display = "block";
    } else {
      topButton.style.display = "none";
    }
  }

  // 当点击按钮时，回到页面顶部
  topButton.addEventListener("click", backToTop);

  function backToTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
});